import { BaseSelector } from './BaseSelector';
import { ExportType } from '../../../../../integrations/exports/models/BatchExport';
import { t } from 'i18next';
import { BatchExportSelector, BatchExportSelectorProps } from './BatchExportSelector';
import JiraIcon from '../../../../../assets/images/export-jira-icon.svg';

type JiraExportSelectorProps = Omit<BatchExportSelectorProps, 'description' | 'disabledReason' | 'onCancel'> & {
  batchExportsEnabled: boolean;
  selectedInstancesCount: number;
  onCancel: (exportType: ExportType) => Promise<void>;
};

export const JiraSelector = ({
  batchExportsEnabled,
  selected,
  loading,
  disabled,
  selectedInstancesCount,
  onSelected,
  exportJob,
  onCancel,
}: JiraExportSelectorProps) => {
  if (!batchExportsEnabled) {
    return (
      <BaseSelector
        title={t('jira')}
        description={t('exportFormats.jira.report')}
        icon={<JiraIcon aria-hidden="true" width="40" height="40" />}
        selected={selected}
        onSelected={onSelected}
        loading={loading ?? false}
        disabled={disabled ?? false}
        disabledReason={t('jiraIsNotConfiguredInYourOrganization')}
      />
    );
  }

  return (
    <BatchExportSelector
      title={t('jira')}
      description={selectedInstancesCount > 0 ? t('exportFormats.jira.multiSelect') : t('exportFormats.jira.batchExport')}
      icon={<JiraIcon aria-hidden="true" width="40" height="40" />}
      selected={selected}
      loading={loading}
      disabled={disabled}
      disabledReason={t('jiraIsNotConfiguredInYourOrganization')}
      onSelected={onSelected}
      exportJob={exportJob}
      onCancel={() => onCancel(ExportType.JIRA)}
    />
  );
};
